// Persisted flag for the Meetings-panel onboarding example state (STARB-4361).
// Once the onboarding is retired — the user dismisses it via the ✕, or a real
// recorded meeting appears — this is set to `'true'` and the example never shows
// again (the panel falls through to the empty state). Per-user, server-side,
// cross-device.
export const MEETINGS_ONBOARDING_RETIRED_KEY = 'meetings-onboarding:retired';

export const MeetingsOnboardingKeys: readonly ['meetings-onboarding:retired'] = [
	MEETINGS_ONBOARDING_RETIRED_KEY,
] as const;
